<template>
    <v-form
        ref="form"
    >
        <v-text-field
            v-model="token"
            label="API token"
            disabled
            required
        ></v-text-field>
        <v-btn
            :disabled="isFetch"
            color="success"
            class="mr-4"
            @click="onGenerate"
        >
            Сгенерировать
        </v-btn>
    </v-form>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import * as api from '@/api/user';
export default {
    name: "ApiTokenForm",
    props:{
    },
    mounted(){
        this.getApiToken();
    },
    data(){
        return {
            isFetch: false,
            token: null,
        }
    },
    watch: {
        token(val){
            this.$emit('token-changed', val);
        }
    },
    methods: {
        ...mapActions('notifications', ['SHOW_SUCCESS', 'SHOW_ERROR', 'SHOW_RESPONSE_ERROR']),
        async onGenerate(){
            try {
                this.isFetch = true;
                let response = await api.generateApiToken(this.USER_ID);
                this.token = response.data.token;
            }catch (e) {
                this.SHOW_RESPONSE_ERROR({errorResponse: e, defaultError: 'Произошла ошибка генерации токена. Повторите попытку'})
                console.log(e);
            }finally {
                this.isFetch = false;
            }
        },
        async getApiToken(){
            try {
                this.isFetch = true;
                let response = await api.getApiToken(this.USER_ID);
                this.token = response.data.token;
            }catch (e) {
                this.SHOW_RESPONSE_ERROR({errorResponse: e, defaultError: 'Произошла ошибка загрузки. Повторите попытку'})
                console.log(e);
            }finally {
                this.isFetch = false;
            }
        }
    },
    computed: {
        ...mapGetters( 'user', ['USER_ID']),
    }
}
</script>

<style scoped>

</style>